import { create } from 'zustand';

import type { MediaInferenceData } from '@/shared/api/persona-service';

interface MediaInferenceViewerStore {
  isOpen: boolean;
  mediaData: MediaInferenceData | null;
  inferenceId: number | null;
  openMedia: (mediaData: MediaInferenceData, inferenceId: number) => void;
  closeMedia: () => void;
}

export const useMediaInferenceViewerStore = create<MediaInferenceViewerStore>((set) => ({
  isOpen: false,
  mediaData: null,
  inferenceId: null,
  openMedia: (mediaData, inferenceId) =>
    set({
      isOpen: true,
      mediaData,
      inferenceId,
    }),
  closeMedia: () =>
    set({
      isOpen: false,
      mediaData: null,
      inferenceId: null,
    }),
}));
